import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import PhotoLibraryOutlinedIcon from '@mui/icons-material/PhotoLibraryOutlined';
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';
import { Button, Grid } from '@mui/material';
import Drawer from '@mui/material/Drawer';
import FormControl from '@mui/material/FormControl';
import { useTheme } from '@mui/material/styles';
import * as React from 'react';
import { IDropDownResponse } from '../../models/registration.model';
import { IDropDown } from './IDropDowm';
import './style.css';
import { requestPermission } from '../../utility/requestPermission';

export default function CustomisedDropDownimage({ title, label, setSelectedItem, options, isSelected, rejected }: IDropDown) {
    const css = `
       .MuiTypography-root{
           font-size: 14px;
       }
       `;
    const [open, setOpen] = React.useState(false);


    const theme = useTheme();

    const handleClick = (item: IDropDownResponse) => {
        setOpen(false);
        setSelectedItem(item)
    }

    const handleOpen = () => {
        if (options != null && options != undefined && options.length > 0 && (rejected === false || rejected === undefined || rejected === null)) {
            setOpen(true)
            requestPermission(['camera'])
        }
    }


    return (
        <div
            style={{
                background: '#fff',
                // borderWidth: '1.5px',
                width: '100%',
                height: '100%',
            }}
        // className="textFieldBorderDesign "
        >
            <FormControl fullWidth style={{
                width: ' 100%',
                height: ' 100%',
            }}>
                <style>{css}</style>
                <Grid
                    container
                    onClick={handleOpen}
                    className="primaryColorLight900  content-center"
                    sx={{
                        height: '100%',
                        alignItems: 'center',
                        fontSize: '14px',
                        paddingRight: "20px",
                        paddingLeft: "15px"
                    }}
                >
                    <Grid container xs={12}>
                        <Grid item xs={12} style={{ alignContent: 'end' }}>
                            <img src="images/upload.svg" alt="Upload" className="text-center block m-auto" style={{ marginBottom: '5px' }} />
                        </Grid>
                        <Grid item xs={12}>

                            <span className="primaryColorLight900 font-bold" style={{ fontSize: '12.5px' }}>
                                بارگذاری تصویر
                            </span>
                        </Grid>
                    </Grid>
                </Grid>
            </FormControl>
            <Drawer
                anchor={'bottom'}
                open={open}
                sx={{ zIndex: 1221 }}
                onClose={() => setOpen(false)}
                PaperProps={{
                    sx: {
                        backgroundColor: 'var(--input-bg-color)',
                    }
                }}

            >
                <Grid
                    container
                    spacing={2}
                    textAlign={'right'}
                    fontSize={'14px'}
                    style={{ justifyContent: "end", paddingBottom: "10px", color: "var(--primary-text-color)", border: "none", fontSize: '1rem' }}
                    className="primaryColorLight-900  dropTitle  px-5 py-5 pt-8 YekanBakhFaNum-Medium"
                    onClick={() => setOpen(false)}
                >
                    {label}
                </Grid>
                <Grid container spacing={2} justifyContent="center" alignItems="center" textAlign="center" margin="auto" width="100%"
                    paddingRight="1vh" paddingLeft="1vh"
                >
                    {options.map((item, index) => (
                        <Grid item xs={4} key={index} style={{ padding: '0px' }}>
                            <Button
                                variant="contained"
                                style={{
                                    backgroundColor: '#fff', height: "13vh",
                                    width: "calc((100% / 3)* 3 - 20px)",
                                    margin: "1vh",
                                    border: " 1px solid var(--border-color)",
                                    boxShadow: '0 2px 8px 0 rgba(255,255,255,0.35)',
                                }}
                                onClick={() => handleClick(item)}
                            >
                                <Grid container justifyContent="center" alignItems="center">
                                    <Grid item xs={12} style={{ color: "#BBA57A", height: "4vh" }}>
                                        {item.icon === "PhotoLibraryOutlinedIcon" ? <PhotoLibraryOutlinedIcon style={{ width: '28px', height: '28px' }} /> : item.icon === "CameraAltOutlinedIcon" ? <CameraAltOutlinedIcon style={{ width: '28px', height: '28px' }} /> : <UploadFileOutlinedIcon style={{ width: '28px', height: '28px' }} />}
                                        <br />
                                        <span style={{ color: "var(--tirnary-text-color)", fontWeight: 'bold' }}>{item.title}</span>
                                    </Grid>
                                </Grid>
                            </Button>
                        </Grid>
                    ))}
                </Grid>
            </Drawer>
        </div>
    );
}
